import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Employee } from '@models/company';
import { LawFirmEmployeeFields } from '@models/lawFirms';
import {
	GenderOptions,
	GenderType,
	TitleOptions,
	TitleType,
} from '@models/clients';
import { createId } from '@core/util/file';
import { DropdownResult } from '../../atomic/atoms/dropdown-options/dropdown-options.component';
import { mapTitleToGender } from '@core/util/client';

@Component({
	selector: 'app-create-employee',
	templateUrl: './create-employee.component.html',
	standalone: false,
})
export class CreateEmployeeComponent implements OnInit {
	public _id;
	public title;
	public _firstName = '';
	public _lastName = '';
	public _email = '';
	public _phoneNumber = '';
	public gender;
	public _workPhone = '';
	public _fax = '';
	public labels = LawFirmEmployeeFields;
	public loading = false;
	public _required = false;

	@Input() set firstName(value: string) {
		this._firstName = value;
	}

	@Input() set lastName(value: string) {
		this._lastName = value;
	}

	@Input() set required(value: boolean) {
		this._required = value;
	}

	public titleOptions = [
		{
			items: TitleOptions,
		},
	];

	public genderOptions = GenderOptions;

	@Input() label = '';
	@Input() checkboxLabel = '';
	@Input() firm;

	@Input() set employee(value: Employee) {
		this._id = value?.id ?? null;
		this.title = value?.title ?? null;
		this._firstName = this._firstName
			? this._firstName
			: (value?.firstName ?? '');
		this._lastName = this._lastName ? this._lastName : (value?.lastName ?? '');
		this._email = value?.email ?? '';
		this._phoneNumber = value?.phoneNumber ?? '';
		this.gender = value?.gender ?? null;
		this._workPhone = value?.workPhone ?? '';
		this._fax = value?.fax ?? '';
	}

	@Output() onSubmit = new EventEmitter<Employee>();

	constructor() {
		this.loading = false;
	}

	ngOnInit(): void {
		this.loading = false;
	}

	_onSubmit(form: NgForm): void {
		if (form.valid) {
			this.loading = true;
			const employee: Employee = {
				id: this._id ?? createId(),
				title: this.title,
				firstName: this._firstName,
				lastName: this._lastName,
				phoneNumber: this._phoneNumber,
				email: this._email,
				gender: this.gender,
				workPhone: this._workPhone,
				fax: this._fax,
			};
			this.onSubmit.emit(employee);
		}
	}

	// rome-ignore lint/suspicious/noExplicitAny: <explanation>
	setTitle($event: DropdownResult<any>) {
		this.title = $event.result.name;
		this.gender = mapTitleToGender($event.result.name as TitleType);
	}

	setAddress($event) {
		if ($event.target.checked) {
			this._workPhone = this.firm.phoneNumber ?? '';
			this._phoneNumber = this.firm.phoneNumber ?? '';
			this._fax = this.firm.faxNumber ?? '';
			this._email = this.firm.email ?? '';
		} else {
			this._workPhone = '';
			this._phoneNumber = '';
			this._fax = '';
			this._email = '';
		}
	}
}
